import flatten from 'lodash/flatten';

import { getUniqChunkedIds } from '@utils/getUniqChunkedIds';

export async function loadWithChunkAndFlatten<D>(
    idsToLoad: string[],
    api: (params: { [key: string]: string }) => Promise<D[]>,
    searchFieldName = 'ids',
): Promise<D[]> {
    const chunkedIds = getUniqChunkedIds(idsToLoad);
    const data = await Promise.all(chunkedIds.map(ids => api({ [searchFieldName]: ids.join(',') })));
    return flatten(data);
}
